
































































































import { mapActions, mapState } from 'vuex';
import * as vr from '@/helpers/validation';
import {
  integer,
  required,
  validNumber,
  positiveNumber
} from '@/helpers/validation';

import {
  updateCopystakeAggregationAggregatorMode,
  updateCopystakeAggregationCasinoMode,
  updateCopystakeAggregatorCasinoConfig,
  updateCopystakeAggregatorOperatorConfig
} from '@/api/CopyStake/Integration';
import { AxiosError } from 'axios';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import {
  CopyStakeAggregationOperatorTypeNaming,
  CopyStakeAggregatorTypeNaming,
  ECopyStakeAggregationOperatorType,
  ECopyStakeAggregatorType,
  TCopystakeOperatorAggregatorCasinoParams,
  TCopystakeOperatorAggregatorOperatorParams
} from '@/api/schema';

type TAggregationSettingsValues = {
  operatorType: ECopyStakeAggregationOperatorType;
  casinoId: string;
  casinoName: string;
  isActive: boolean;
  apiKey: string;
  callbackUrl: string;
  ttl: number;
  aggregatorType: ECopyStakeAggregatorType;
  aggregatorEnabled: boolean;
};

type TAggregationSettingsData = {
  ECopyStakeAggregationOperatorType?: typeof ECopyStakeAggregationOperatorType;
  operatorTypeList: ReadonlyArray<{
    text: string;
    value: ECopyStakeAggregationOperatorType;
  }>;
  aggregatorTypeList: ReadonlyArray<{
    text: string;
    value: ECopyStakeAggregatorType;
  }>;

  values: TAggregationSettingsValues;
  formValid: boolean;
  isSubmitting: boolean;
};

type TValidator = (v: string) => boolean | string;

export default {
  name: 'OnboardingCopystakeAggregationSettings',
  props: {
    brandName: {
      type: String,
      default: (): string => ''
    }
  },
  data(): TAggregationSettingsData {
    return {
      ECopyStakeAggregationOperatorType,
      operatorTypeList: Object.freeze([
        {
          text: CopyStakeAggregationOperatorTypeNaming.CASINO,
          value: ECopyStakeAggregationOperatorType.CASINO
        },
        {
          text: CopyStakeAggregationOperatorTypeNaming.AGGREGATOR,
          value: ECopyStakeAggregationOperatorType.AGGREGATOR
        }
      ]),
      aggregatorTypeList: Object.freeze([
        {
          text: CopyStakeAggregatorTypeNaming.PLATIPUS,
          value: ECopyStakeAggregatorType.PLATIPUS
        }
      ]),

      values: {
        operatorType: null,

        casinoId: null,
        casinoName: null,
        isActive: false,

        apiKey: null,
        callbackUrl: null,
        ttl: null,
        aggregatorType: null,
        aggregatorEnabled: false
      },

      formValid: false,
      isSubmitting: false
    };
  },
  computed: {
    ...mapState('Onboarding', ['copyStakeAggregationConfig', 'loading']),
    isCasinoOperatorType(): boolean {
      return (
        this.values.operatorType === ECopyStakeAggregationOperatorType.CASINO
      );
    },
    isAggregatorOperatorType(): boolean {
      return (
        this.values.operatorType ===
        ECopyStakeAggregationOperatorType.AGGREGATOR
      );
    },

    isConfigUpdated(): boolean {
      if (this.isCasinoOperatorType) {
        return (
          this.values.casinoId !== this.copyStakeAggregationConfig.casinoId ||
          this.values.casinoName !==
            this.copyStakeAggregationConfig.casinoName ||
          this.brandName !== this.copyStakeAggregationConfig.brandName
        );
      } else if (this.isAggregatorOperatorType) {
        return (
          this.values.apiKey !== this.copyStakeAggregationConfig.apiKey ||
          this.values.callbackUrl !==
            this.copyStakeAggregationConfig.callbackUrl ||
          this.values.ttl !== this.copyStakeAggregationConfig.ttl ||
          this.values.aggregatorType !==
            this.copyStakeAggregationConfig.aggregatorType ||
          this.brandName !== this.copyStakeAggregationConfig.brandName
        );
      } else {
        return false;
      }
    },
    isStatusUpdated(): boolean {
      if (this.isCasinoOperatorType) {
        return (
          this.values.isActive !== !!this.copyStakeAggregationConfig.isActive
        );
      } else if (this.isAggregatorOperatorType) {
        return (
          this.values.aggregatorEnabled !==
          !!this.copyStakeAggregationConfig.aggregatorEnabled
        );
      } else {
        return false;
      }
    },
    isBrandNameUpdated(): boolean {
      return this.brandName !== this.copyStakeAggregationConfig.brandName;
    },
    isShowEnableSwitch(): boolean {
      if (this.isCasinoOperatorType) {
        return !!(
          this.copyStakeAggregationConfig.casinoId &&
          this.copyStakeAggregationConfig.casinoName
        );
      } else if (this.isAggregatorOperatorType) {
        return !!(
          this.copyStakeAggregationConfig.apiKey &&
          this.copyStakeAggregationConfig.callbackUrl &&
          this.copyStakeAggregationConfig.ttl &&
          this.copyStakeAggregationConfig.aggregatorType
        );
      } else {
        return false;
      }
    },
    isLoading(): boolean {
      return this.loading.copyStakeAggregationConfig;
    },
    isDisabledFields(): boolean {
      return this.isSubmitting || this.isLoading;
    },
    isDisabledOperatorTypeSelect(): boolean {
      return !!(
        this.isDisabledFields || this.copyStakeAggregationConfig.operatorType
      );
    },
    isDisabledSubmitBtn(): boolean {
      return (
        !(
          this.isConfigUpdated ||
          this.isStatusUpdated ||
          this.isBrandNameUpdated
        ) ||
        !this.formValid ||
        !this.brandName ||
        this.isSubmitting
      );
    },

    validationRules(): {
      operatorType: TValidator[];
      casinoId: TValidator[];
      casinoName: TValidator[];
      apiKey: TValidator[];
      callbackUrl: TValidator[];
      ttl: TValidator[];
      aggregatorType: TValidator[];
    } {
      return {
        operatorType: [(v) => required(v, 'Operator Type')],

        casinoId: [(v) => required(v, 'Casino ID')],
        casinoName: [(v) => required(v, 'Casino Name')],

        apiKey: [(v) => required(v, 'API Key')],
        callbackUrl: [(v) => required(v, 'Callback URL'), vr.url],
        ttl: [
          (v) => required(v, 'TTL'),
          integer,
          validNumber,
          positiveNumber
        ],
        aggregatorType: [(v) => required(v, 'Aggregator Type')]
      };
    }
  },
  mounted(): void {
    this.parseSavedSettings();
  },
  watch: {
    'values.operatorType': {
      handler(newVal: string): void {
        this.$emit('changeOperatorType', newVal);
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('Onboarding', ['getCopyStakeAggregationConfigData']),
    parseSavedSettings(): void {
      this.getCopyStakeAggregationConfigData()
        .then(() => {
          this.values.operatorType =
            this.copyStakeAggregationConfig.operatorType ||
            ECopyStakeAggregationOperatorType.CASINO;

          this.values.casinoId =
            this.copyStakeAggregationConfig.casinoId || null;
          this.values.casinoName =
            this.copyStakeAggregationConfig.casinoName || null;
          this.values.isActive =
            this.copyStakeAggregationConfig.isActive || false;

          this.values.apiKey = this.copyStakeAggregationConfig.apiKey || null;
          this.values.callbackUrl =
            this.copyStakeAggregationConfig.callbackUrl || null;
          this.values.ttl = this.copyStakeAggregationConfig.ttl || null;
          this.values.aggregatorType =
            this.copyStakeAggregationConfig.aggregatorType ||
            ECopyStakeAggregatorType.PLATIPUS;
          this.values.aggregatorEnabled =
            this.copyStakeAggregationConfig.aggregatorEnabled || false;
        })
        .catch((err: AxiosError) => {
          errorToastMessage(err);
        });
    },
    changeOperatorTypeHandler(): void {
      this.$refs.form?.resetValidation();
    },
    submitHandler(): void {
      if (this.isSubmitting) return;

      if (this.isCasinoOperatorType) {
        this.updateAggregatorCasinoConfig();
      } else if (this.isAggregatorOperatorType) {
        this.updateAggregatorOperatorConfig();
      }
    },
    updateAggregatorOperatorConfig(): void {
      this.isSubmitting = true;

      const promises = [];

      if (this.isConfigUpdated) {
        const config: TCopystakeOperatorAggregatorOperatorParams = {
          apiKey: this.values.apiKey,
          ttl: this.values.ttl,
          callbackUrl: this.values.callbackUrl,
          brandName: this.brandName,
          aggregatorType: this.values.aggregatorType,
          aggregatorEnabled: this.values.aggregatorEnabled
        };

        promises.push(updateCopystakeAggregatorOperatorConfig(config));
      } else if (this.isStatusUpdated) {
        promises.push(
          updateCopystakeAggregationAggregatorMode(
            this.values.aggregatorEnabled
          )
        );
      }

      Promise.all(promises)
        .then((): void => {
          this.$toast.success(
            'CopyStake Aggregator Operator settings updated.'
          );

          this.parseSavedSettings();
        })
        .catch(() => {
          this.$toast.error(
            'CopyStake Aggregator Operator settings update failed.'
          );
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    updateAggregatorCasinoConfig(): void {
      this.isSubmitting = true;

      const promises = [];

      if (this.isConfigUpdated) {
        const config: TCopystakeOperatorAggregatorCasinoParams = {
          casinoId: this.values.casinoId,
          casinoName: this.values.casinoName,
          brandName: this.brandName
        };

        promises.push(updateCopystakeAggregatorCasinoConfig(config));
      }

      if (this.isStatusUpdated) {
        promises.push(
          updateCopystakeAggregationCasinoMode(this.values.isActive)
        );
      }

      Promise.all(promises)
        .then((): void => {
          this.$toast.success(
            'CopyStake Aggregator Casino settings updated.'
          );

          this.parseSavedSettings();
        })
        .catch(() => {
          this.$toast.error(
            'CopyStake Aggregator Casino settings update failed.'
          );
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    }
  }
};
